{
	"id": 7502,
	"moduleNumber": 2,
	"slug": "module-2",
	"kgNodeId": "module-2",
	"title": "The Professional Educator",
	"subtitle": "Act proactively to uphold ethical standards, protect students, and address colleague concerns responsibly.",
	"type": "lesson",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"sourceStatus": "extracted_from_source_documents",
	"summary": "Module 2 introduces the educator's professional role through a colleague-concern scenario centered on Ms. Kim, whose teaching style changes over a short period and appears to reduce student engagement. Learners distinguish collegial support from professional responsibility and decide when referral or escalation is appropriate.",
	"estimatedDurationMinutes": 35,
	"activityCount": 2,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	},
	"learningObjectives": [
		"Distinguish between actions appropriate to the educator role and actions requiring referral.",
		"Analyze how dispositional and regulatory frameworks influence ethical decision making.",
		"Evaluate competing tensions to select actions aligned with ethical principles.",
		"Apply MCEE-aligned decision criteria to resolve ethical scenarios."
	],
	"flow": [
		"Getting familiar with the course.",
		"Scenario: A Colleague's Role.",
		"Video: seventh-grade science lesson.",
		"Perspectives: teacher-lounge discussion among colleagues.",
		"Reflect: dispositional versus regulatory framework.",
		"Explore: ethical principles and guiding questions.",
		"Review: apply principles to the scenario.",
		"Analysis: choose an appropriate course of action.",
		"Ethical Situations: Educator Professional Integrity.",
		"Five-question end-of-module knowledge check."
	],
	"scenarios": [
		{
			"id": "module-2-colleague-role",
			"title": "A Colleague's Role",
			"summary": "Ms. Kim's teaching style changes, students appear less engaged, and colleagues discuss how to respond. Learners decide whether the response is driven by personal dispositions or regulatory/professional responsibilities."
		}
	],
	"ethicalSituations": [
		"Student Disclosure",
		"Parent Pressure",
		"Mentor",
		"Celebration",
		"Donation",
		"Performance Task",
		"Tutoring",
		"Digital Sharing",
		"Safety Concern",
		"Social Media"
	],
	"ethicalPrinciples": [
		"Promoting Solution Discovery",
		"Risk Mitigation",
		"Objectivity and Neutrality Are Maintained",
		"Ensuring Student Welfare",
		"Transparency in Actions and Communications",
		"Honoring the Boundaries of Role, Time, and Place",
		"Integrity of the Profession Is Promoted by the Educator",
		"Code of Ethics for Educators Is Maintained with Fidelity",
		"Stewardship of the Law and Public Trust"
	],
	"sources": {
		"curriculum": "../../../../.working/Praxis ProEthics/Content/curriculum/modules/module-2/module.md",
		"primary": "../../../../.working/Praxis ProEthics/Content/Module 2/Module 2_Rise and Storyline Version V3_UPDATED.docx",
		"scorm": "../../../../.working/Praxis ProEthics/Content/Module 2/SCORM/Module 2_Rise and Storyline Version V3_UPDATED.docx",
		"transcripts": [
			"../../../../.working/Praxis ProEthics/Content/Module 2/Dialogue Transcript/7th grade science dialogue_transcript__V2.docx",
			"../../../../.working/Praxis ProEthics/Content/Module 2/Dialogue Transcript/m2s1p1_Teacher lounge dialogue_transcript_Updated.docx"
		],
		"videos": []
	}
}
